import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { FC, memo, useEffect } from 'react';

export type SearchErrorFallbackProps = {
  error: Error | null;
};

export const SearchErrorFallback: FC<SearchErrorFallbackProps> = memo(
  ({ error }) => {
    const { t } = useTranslation();
    const notify = useToastAPI();
    const errorMessage = error?.message;

    useEffect(() => {
      notify.error({
        title: errorMessage ?? t('system_error'),
        duration: 3000,
      });
    }, [errorMessage, notify, t]);

    return null;
  }
);
SearchErrorFallback.displayName = 'SearchErrorFallback';
